var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "capusta-panel",
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    staticClass: "capusta-panel-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.getIconUrl(_vm.icon),
      "alt": _vm.icon
    }
  })]), _c('div', {
    staticClass: "capusta-panel-description"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }